import React from 'react';
import styled from 'styled-components';
import SubLayout from '../components/layout/SubLayout';
import { businessMenus } from '../data/businessMenus';

const Intro = styled.p`
  font-size: 1.05rem;
  color: #555;
  line-height: 1.9;
  margin-bottom: 50px;
`;

const ServiceGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 20px;
  margin-bottom: 50px;
`;

const ServiceCard = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 30px 25px;
  background: #fff;
  transition: box-shadow 0.2s ease, border-color 0.2s ease;

  &:hover {
    box-shadow: 0 6px 20px rgba(0, 86, 179, 0.1);
    border-color: #27ae60;
  }

  .icon { font-size: 2rem; margin-bottom: 12px; }
  h4 { font-size: 1.1rem; color: #222; margin-bottom: 8px; }
  p { font-size: 0.9rem; color: #666; line-height: 1.7; }
`;

const SectionLabel = styled.h3`
  font-size: 1.3rem;
  color: #1a2a40;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #e0e0e0;
`;

const FeatureBox = styled.div`
  background: #f0faf4;
  border-left: 4px solid #27ae60;
  padding: 20px 25px;
  border-radius: 0 8px 8px 0;
  margin-bottom: 15px;

  h4 { font-size: 1rem; color: #333; margin-bottom: 6px; }
  p { font-size: 0.9rem; color: #666; line-height: 1.6; }
`;


const BusinessLandscape = () => {
  return (
    <SubLayout
      title="조경식재"
      sidebarMenus={businessMenus}
      category="사업영역"
      categoryEn="Business"
      bannerBg="/images/bg_landscape.jpg"
    >
      <Intro>
        주식회사 두성시스템은 도심 속 쾌적한 녹색 환경을 조성합니다.
        공공기관, 아파트 단지, 기업 사옥 등 다양한 공간에 전문적인 조경 설계와 식재 시공 서비스를 제공합니다.
        자연과 사람이 공존하는 아름다운 환경을 만들겠습니다.
      </Intro>

      <SectionLabel>주요 서비스</SectionLabel>
      <ServiceGrid>
        <ServiceCard>
          <div className="icon">🌳</div>
          <h4>수목 식재</h4>
          <p>교목, 관목, 지피류 등 다양한 수목의 전문적인 식재 및 관리 서비스를 제공합니다.</p>
        </ServiceCard>
        <ServiceCard>
          <div className="icon">🌱</div>
          <h4>잔디 조성</h4>
          <p>운동장, 공원, 아파트 단지 등의 잔디 식재 및 유지 관리를 담당합니다.</p>
        </ServiceCard>
        <ServiceCard>
          <div className="icon">🌸</div>
          <h4>화단 조성</h4>
          <p>계절별 화훼 식재와 연간 관리 계획을 수립하여 아름다운 화단을 유지합니다.</p>
        </ServiceCard>
        <ServiceCard>
          <div className="icon">⛲</div>
          <h4>조경 시설물</h4>
          <p>정자, 파고라, 벤치, 분수 등 각종 조경 시설물 설치 및 유지 보수를 수행합니다.</p>
        </ServiceCard>
      </ServiceGrid>

      <SectionLabel>특장점</SectionLabel>
      <FeatureBox>
        <h4>전문 조경 기술자 보유</h4>
        <p>조경기사 자격을 보유한 전문 기술자가 직접 설계부터 시공까지 책임지고 수행합니다.</p>
      </FeatureBox>
      <FeatureBox>
        <h4>친환경 시공</h4>
        <p>환경 친화적인 자재와 공법을 사용하여 생태계와 조화를 이루는 조경을 실현합니다.</p>
      </FeatureBox>
      <FeatureBox>
        <h4>연간 유지관리 서비스</h4>
        <p>시공 후 계절별 전정, 시비, 병충해 방제 등 연간 유지 관리 서비스를 제공합니다.</p>
      </FeatureBox>
    </SubLayout>
  );
};

export default BusinessLandscape;
